import { Typography } from '@weareopenr/component-library';
import CollapsibleSection from 'src/components/CollapsibleSection';
import { IPublishDestination } from '../../types';
import { destinationId } from '../../utilities/destinationId/destinationId';
import styles from '../SummaryView.module.scss';

interface IChannelsSummarySectionProps {
  number: string;
  publicationData: IPublishDestination[];
  selectedChannelIds: string[];
}

const ChannelsSummarySection = ({ number, publicationData, selectedChannelIds }: IChannelsSummarySectionProps) => {
  const selectedChannelSet = new Set(selectedChannelIds);
  const selectedChannels = publicationData.filter((channel) => selectedChannelSet.has(destinationId(channel)));

  return (
    <CollapsibleSection
      number={number}
      title="Channels"
      subtitle={`${selectedChannels.length} ${selectedChannels.length === 1 ? 'channel' : 'channels'} selected`}
    >
      <div className={styles['channel-container']}>
        <div className={styles['venue-container']}>
          {selectedChannels.map((channel) => (
            <div key={destinationId(channel)}>
              <Typography>{channel.name}</Typography>
            </div>
          ))}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default ChannelsSummarySection;
